import React from 'react';

import { GoogleRecaptcha } from './google/GoogleRecaptcha';
import { YandexCaptcha } from './yandex/YandexCaptcha';

export const CaptchaSubscribeManager = ({
    handleToken,
}: {
    handleToken: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const provider = process.env.REACT_APP_CAPTCHA_PROVIDER || 'yandex';

    if (provider === 'google') {
        return <GoogleRecaptcha setToken={handleToken} />;
    }

    return <YandexCaptcha setToken={handleToken} />;
};
